import type { OccurrencesResult } from "@/api/repeat";

export default (occurrences?: OccurrencesResult): boolean => {
  if (!occurrences) {
    return false;
  }

  const { status, data } = occurrences;

  if (status === "infinite") {
    return true;
  }

  // Only valid if we have successful data with occurrences
  if (status === "success") {
    return Array.isArray(data) && data.length > 0;
  }

  return false;
};
